/**
 * PRCM-10837: one-shot flag coordinating the overlay-textarea rAF reselect
 * with the editor's global outside-click handler on desktop, where a `click`
 * event after mouseup would otherwise discard the just-restored selection.
 *
 * On desktop, native `blur` fires DURING `mousedown` (before `mouseup`), which
 * synchronously runs `onTextareaBlur` → `markPendingOverlayReselect` → rAF.
 * The rAF itself may fire between `mousedown` and `mouseup`, so we cannot
 * clear the flag inside the rAF — mouseup (and then click) still need to see
 * it set. Auto-clear with a short safety timeout instead so the flag can't
 * get stuck if the click event is somehow suppressed.
 */
const AUTO_CLEAR_MS = 500;

let pending = false;
let autoClearHandle: ReturnType<typeof setTimeout> | null = null;

const clearTimer = (): void => {
  if (autoClearHandle !== null) {
    clearTimeout(autoClearHandle);
    autoClearHandle = null;
  }
};

export const markPendingOverlayReselect = (): void => {
  pending = true;
  clearTimer();
  autoClearHandle = setTimeout(() => {
    pending = false;
    autoClearHandle = null;
  }, AUTO_CLEAR_MS);
};

export const isPendingOverlayReselect = (): boolean => pending;

export const consumePendingOverlayReselect = (): boolean => {
  const was = pending;
  pending = false;
  clearTimer();
  return was;
};

export const resetPendingOverlayReselect = (): void => {
  pending = false;
  clearTimer();
};
